'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to confirm action button on MyProducts
 */
    .directive('capMyproductsActionConfirmation', function () {
        return {
            restrict: 'A',
            scope: {
                product: "=",
                productOption: "=",
                action: "=",
                actions: "="
            },
            templateUrl: "templates/myproductsactionconfirmation.html"
        }
    });